module.exports = __webpack_public_path__ + "img/wb_tpt.1bb39d9c.jpg";